import { search } from './searchService';
import { post, put, del, getById } from './apiService';
import type { RetellAIAgent } from '../types/aiAgent';
import type { SearchParams } from '../types/search';

export async function searchAIAgents(
  filter: object = {},
  params: SearchParams = {},
): Promise<RetellAIAgent[]> {
  return search<RetellAIAgent>('/retell-ai-agent/search', filter, params);
}

export async function getAIAgentById(id: string): Promise<RetellAIAgent> {
  return getById<RetellAIAgent>('/retell-ai-agent', id);
}

export async function createAIAgent(data: {
  retellAgentId: string;
  name: string;
  active?: boolean;
  contextData?: RetellAIAgent['contextData'];
}): Promise<RetellAIAgent> {
  return post<RetellAIAgent>('/retell-ai-agent', data);
}

export async function updateAIAgent(
  id: string,
  data: RetellAIAgent,
): Promise<RetellAIAgent> {
  return put<RetellAIAgent>(`/retell-ai-agent/${id}`, data);
}

export async function deleteAIAgent(id: string): Promise<void> {
  return del<void>(`/retell-ai-agent/${id}`);
}
